import * as React from 'react';

export const LogoIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 33 35"
    width={33}
    height={35}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      d="M17.276 0c5.4 0 8.1 0 10.163 1.058A9.675 9.675 0 0 1 31.653 5.3c1.051 2.077 1.051 4.795 1.051 10.232v3.802c0 5.436 0 8.155-1.05 10.231a9.675 9.675 0 0 1-4.215 4.243c-2.063 1.058-4.763 1.058-10.163 1.058h-1.847c-5.4 0-8.101 0-10.164-1.058a9.675 9.675 0 0 1-4.214-4.243C0 27.49 0 24.77 0 19.334v-3.802C0 10.095 0 7.377 1.051 5.3a9.676 9.676 0 0 1 4.214-4.242C7.328 0 10.028 0 15.43 0h1.847Z"
    />
    <path
      fill="#25282E"
      d="m19.423 17.005 6.57-2.001-2.857 10.574H11.39l1.892-7.716-6.57 1.572L9.426 9.288h11.996l-2 7.716Z"
    />
  </svg>
);
